//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
    name: 'chargeback-model-view',
    props: {
        value: {
            type: Boolean,
            required: true
        },
        workOrderId: {
            type: Number,
            required: true
        }
    },
    data() {
        return {
            saving: false,
            chargeBackInputDto: {},
            rules: {}
        };
    },
    methods: {
        visibleChange(value) {
            if (!value) {
                this.$emit('input', value);
            }
        },
        cancel() {
            this.$refs.cancelOrderForm.resetFields();
            this.$emit('input', false);
        },
        onSaveChargeBack() {
            var vm = this;
            this.$refs.cancelOrderForm.validate(async (val) => {
                if (val) {
                    // console.log(vm.startHandleDto);
                    vm.saving = true;
                    abp.ajax.post('/api/services/app/WorkOrder/SaveCancelOrder', vm.cancelOrderInputDto).then(() => {
                        vm.getWorkOrderById();
                        vm.getCancelOrderList();
                        vm.showCancelOrderModel = false;
                    }).finally(() => {
                        vm.saving = false;
                    });
                }
            });
        }
    },
    created() {
    }
};
